import { Injectable } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root',
})
export class UrlService {

  constructor(
    private jwtAuthService: JwtAuthService,
    private featureFlagService: FeatureFlagService) {
  }

  organizationsList(): string {
    return '/organizacoes';
  }

  organizationsBase(id: unknown): string {
    return [this.organizationsList(), id].join('/');
  }


  onboardingFileUpload(type: string) {
    return `/paciente/home/enviar-exames/onboarding/${ type }`;
  }

  fileUpload(type: FileUpload) {
    return `/paciente/home/enviar-exames/${ type }`;
  }


  login(type: LoginType) {
    if (type === 'INTRO') {
      return '/paciente/login/boas-vindas';
    }
    if (type === 'DOCUMENT') {
      return '/paciente/login/cpf';
    }
    if (type === 'PHONE') {
      return '/paciente/login/telefone';
    }
    if (type === 'SIGNUP') {
      return '/paciente/login/cadastro';
    }
    if (type === 'CODE') {
      return '/paciente/login/codigo';
    }
    if (type === 'NAME') {
      return '/paciente/login/nome';
    }
    if (type === 'BIOLOGICAL_SEX') {
      return '/paciente/login/sexo-biologico';
    }
    if (type === 'BIRTHDATE') {
      return '/paciente/login/aniversario';
    }

    if (type === 'GENDER_TYPE') {
      return '/paciente/login/genero-tipo';
    }

    if (type === 'GENDER') {
      return '/paciente/login/genero';
    }

    if (type === 'GENDER_OTHER') {
      return '/paciente/login/genero-outro';
    }

  }


  loginDataConfirmation(type: LoginType) {
    if (type === 'AGE') {
      return '/paciente/confirmacao/idade';
    }

    if (type === 'GENDER_TYPE') {
      return '/paciente/confirmacao/genero-tipo';
    }

    if (type === 'GENDER') {
      return '/paciente/confirmacao/genero';
    }

    if (type === 'GENDER_OTHER') {
      return '/paciente/confirmacao/genero-outro';
    }

    if (type === 'BIOLOGICAL_SEX') {
      return '/paciente/confirmacao/sexo-biologico';
    }

    if (type === 'NEXT_QUESTIONS') {
      return '/paciente/confirmacao/proximas-perguntas';
    }

  }

  patientAuthorization() {
    return '/paciente/autorizacao';
  }

  patientOnboarding() {
    return '/paciente/onboarding';
  }

  personList(): string {
    return '/pessoas';
  }

  personDetailsBase(id: unknown) {
    return [this.personList(), id].join('/');
  }

  personDetails(id: unknown) {
    const url = [this.personDetailsBase(id), 'exames'];
    return url.join('/');
  }

  personDetailsEdit(id: unknown) {
    const url = [this.personDetailsBase(id), 'dados-paciente'];
    return url.join('/');
  }

  personDetailsReferrals(id: unknown) {
    const url = [this.personDetailsBase(id), 'encaminhamentos'];
    return url.join('/');
  }

  personDetailsFindings(id: unknown) {
    const url = [this.personDetailsBase(id), 'diagnosticos'];
    return url.join('/');
  }

  personDetailsPrevious(id: unknown) {
    const url = [this.personDetailsBase(id), 'previous'];
    return url.join('/');
  }

  personDetailsRisk(personId: unknown, id?: unknown) {
    let url;
    if (id) {
      url = [this.personDetailsBase(personId), 'riscos', id];
    } else {
      url = [this.personDetailsBase(personId), 'riscos'];
    }
    return url.join('/');
  }

  personDetailsLifeHabits(personId: unknown, id?: unknown) {
    let url;
    if (id) {
      url = [this.personDetailsBase(personId), 'habitos-de-vida', id];
    } else {
      url = [this.personDetailsBase(personId), 'habitos-de-vida'];
    }
    return url.join('/');
  }

  personDetailsForms(id: unknown, formSubmissionId?) {
    let url;
    if (formSubmissionId) {
      url = [this.personDetailsBase(id), 'formulario', formSubmissionId];
    } else {
      url = [this.personDetailsBase(id), 'formulario'];
    }
    return url.join('/');
  }

  personDetailsHistory(id: unknown, formSubmissionId?) {
    let url;
    if (formSubmissionId) {
      url = [this.personDetailsBase(id), 'historico', formSubmissionId];
    } else {
      url = [this.personDetailsBase(id), 'historico'];
    }
    return url.join('/');
  }

  personStatusEnding(): string {
    let url = ['/paciente', 'ending'];
    return url.join('/');
  }

  personWaitingPage(): string {
    let url = ['/paciente', 'aguardando'];
    return url.join('/');
  }

  personHome(): string {
    let url = ['/paciente', 'home'];
    return url.join('/');
  }

  personWaitingContact(): string {
    let url = ['/paciente', 'aguardando-contato'];
    return url.join('/');
  }

  personHomeWomanArea(): string {
    let url = [this.personHome(), 'area-da-mulher'];
    return url.join('/');
  }

  personHomeWomanAreaAboutViolence(): string {
    let url = [this.personHomeWomanArea(), 'sofri-mesmo-violencia-duvida'];
    return url.join('/');
  }

  personHomeWomanAreaViolenceWhatNow(): string {
    let url = [this.personHomeWomanArea(), 'sofri-violencia-e-agora'];
    return url.join('/');
  }

  personHomeWomanAreaWhereToGetHelp(): string {
    let url = [this.personHomeWomanArea(), 'onde-conseguir-ajuda'];
    return url.join('/');
  }

  personHomeWomanAreaSafetyPlan(): string {
    let url = [this.personHomeWomanArea(), 'plano-de-seguranca'];
    return url.join('/');
  }

  personHomeExamParses(): string {
    let url = [this.personHome(), 'enviar-exames'];
    return url.join('/');
  }

  personHomeExamRequest(): string {
    let url = [this.personHome(), 'pedidos-de-exame'];
    return url.join('/');
  }

  personHomeExamCollector(): string {
    let url = ['/paciente', 'integracao-exames'];
    return url.join('/');
  }

  personHomeExams(): string {
    let url = [this.personHome(), 'exames'];
    return url.join('/');
  }

  personHomeExamRequestInstructions(): string {
    let url = [this.personHome(), 'preparo-de-exame'];
    return url.join('/');
  }

  personHomeExamRequestReason(): string {
    let url = [this.personHome(), 'motivos-solicitacao'];
    return url.join('/');
  }

  personHomeSummary(): string {
    const isV4 = this.featureFlagService.hasFlagEnable(['PATIENT_APP_PATIENT_SUMMARY_V4']);
    const locale = this.jwtAuthService?.locale;
    let url = [this.personHome()];
    if (isV4 || locale === 'en_US') {
      url.push('relatorio-saude');
      url.push('home');
    } else {
      url.push('relatorio-saude-parcial');
    }
    return url.join('/');
  }

  personHomePreviousExams(): string {
    let url = [this.personHome(), 'exames-previos'];
    return url.join('/');
  }

  personSummaryHome(personId?: number): string {
    return this.personHome();
  }

  personSummary(personId?: number): string {
    const isV4 = this.featureFlagService.hasFlagEnable(['PATIENT_APP_PATIENT_SUMMARY_V4']);
    const locale = this.jwtAuthService?.locale;
    let url = [this.personHome()];
    if (isV4 || locale === 'en_US') {
      url.push('relatorio-saude');
      url.push('home');
    } else {
      url.push('relatorio-saude');
    }
    return url.join('/');
  }

  personPerformedExams(personId?: number): string {
    let url = [this.personSummaryHome(), 'resultados-exames'];
    return url.join('/');
  }

  personBloodPressurePage(): string {
    let url = [this.personHome(), 'pressao-arterial'];
    return url.join('/');
  }

}


export type LoginType =
  'INTRO'
  | 'DOCUMENT'
  | 'PHONE'
  | 'SIGNUP'
  | 'CODE'
  | 'NAME'
  | 'BIRTHDATE'
  | 'BIOLOGICAL_SEX'
  | 'AGE'
  | 'GENDER'
  | 'GENDER_TYPE'
  | 'GENDER_OTHER'
  | 'NEXT_QUESTIONS';
export type FileUpload = 'capture' | 'exames' | 'crop' | 'confirmation';
